<template>
    <div class="grid-item grid-item-half position-relative" v-fs-block>
        <v-inline-loader v-if="isLoadingOrganization" />
        <h2 class="stack-s">{{organization.name}}</h2>
        <p v-if="organization.address" class="text-muted">{{organization.address}}</p>
        <p v-if="organization.address2" class="text-muted">{{organization.address2}}</p>
        <p v-if="organization.city || organization.region || organization.postalCode" class="text-muted">
            {{organization.city}} {{organization.region}} {{organization.postalCode}}
        </p>
        <p v-if="organization.country" class="text-muted">{{organization.country}}</p>
        <ul class="list list-group" v-if="organization.phoneNumbers && organization.phoneNumbers.length">
            <li v-for="(phoneNumber, index) in organization.phoneNumbers" :key="index">
                <span v-if="phoneNumber.primary" class="text-muted">{{phoneNumber.value}} ({{phoneNumber.label}})</span>
            </li>
        </ul>
        <ul class="list list-group" v-if="organization.emails && organization.emails.length">
            <li v-for="(email, index) in organization.emails" :key="index">
                <a v-if="email.primary" :href="`mailto:${email.value}`">{{email.value}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
    import vInlineLoader from '@/components/v-inline-loader';
    import InvoiceModel from '@/common/models/invoice-model';
    import OrganizationModel from '@/common/models/organization-model';

    export default {
        components: {vInlineLoader},
        props: {
            invoice: {
                type: InvoiceModel,
                required: true,
            },
        },
        data() {
            return {
                isLoadingOrganization: false,
                organization: new OrganizationModel(),
            };
        },
        watch: {
            entity() {
                this.fetchData();
            },
        },
        methods: {
            async fetchData() {
                this.isLoadingOrganization = true;
                try {
                    if (this.invoice.organization) {
                        this.organization = this.invoice.organization;
                    } else {
                        const params = {
                            id: this.invoice.organizationId,
                        };
                        const {fields} = await this.$api(({companies}) => companies.get(params));
                        this.organization = new OrganizationModel(fields);
                    }
                    this.isLoadingOrganization = false;
                    this.$emit('organization-loaded', {organization: this.organization});
                } catch (error) {
                    this.$toast.fromError(error);
                }
            },
        },
        created() {
            this.fetchData();
        },
    };
</script>
